(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["papaya_hook_section-backup"] && !window.DesignMode) return;
  try {
    
  $(document).ready(() => {  
 $('.mybtn').click(function(){
  if( $('.mybtn').text()=='SHOW LESS'){
       $(".place:gt(2)").hide();
       $('.mybtn').html('SEE 5 MORE PLACES');  
  }
   else{
      $('.place').show();
      $('.mybtn').html('SHOW LESS');       
   }
   
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papaya_hook_section"] && !window.DesignMode) return;
  try {
    
  $(document).ready(() => {  
 $('.mybtn').click(function(){
  if( $('.mybtn').text()=='SHOW LESS'){
       $(".place:gt(2)").hide();
       $('.mybtn').html('SEE 5 MORE PLACES');  
  }
   else{
      $('.place').show();
      $('.mybtn').html('SHOW LESS');       
   }
   
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-columns-backup"] && !window.DesignMode) return;
  try {
    
  var windowSize = $(window).width();

  if (windowSize <= 479) {
    $('.product-slick').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
        dots: true
    });
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-columns"] && !window.DesignMode) return;
  try {
    
  var windowSize = $(window).width();

  if (windowSize <= 479) {
    $('.product-slick').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
        dots: true
    });
  }
  

  } catch(e) { console.error(e); }
})();
})();
